module.exports = __webpack_public_path__ + "static/img/database-logo.651bbeb.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/database-logo.jpeg
// module id = YE6J
// module chunks = 10